import actionsComponent from './actions.component';
import actionsRoutes from './actions.routes';

angular.module('rym.actions', []).component('rymActions', actionsComponent).run(actionsRoutes);
